module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2 text-xs-left grey-lighten-4",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.chips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadDailyUpdateBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(chip) + "\n                    ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.enableChip === 'Specific Date') ? _c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-sm-right",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lDate
    },
    on: {
      "update:returnValue": function($event) {
        _vm.lDate = $event
      },
      "update:return-value": function($event) {
        _vm.lDate = $event
      }
    },
    model: {
      value: (_vm.dlgDate),
      callback: function($$v) {
        _vm.dlgDate = $$v
      },
      expression: "dlgDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lDate),
      callback: function($$v) {
        _vm.lDate = $$v
      },
      expression: "lDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lDate),
      callback: function($$v) {
        _vm.lDate = $$v
      },
      expression: "lDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgDate.save(_vm.lDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadDailyAllUpdates(_vm.lDate)
      }
    }
  }, [_vm._v("Go")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.lDailyUpdate && _vm.lDailyUpdate.is_sub_app === 0 && _vm.lDailyUpdate.is_app === 0) ? _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.submitApproval
    }
  }, [_vm._v("Submit for Approval")]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdate && _vm.lDailyUpdate.is_sub_app === 1 && _vm.lDailyUpdate.is_app === 0 && !_vm.config.ROLE_NAME.includes('Facility Manager') && !_vm.config.ROLE_NAME.includes('Helpdesk')) ? _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.approveUpdate
    }
  }, [_vm._v("Approve Daily Update")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.lDailyUpdate.c_date) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    attrs: {
      "value": "true",
      "color": "info"
    }
  }, [_vm._v("\n                No data is available for choosen date. You may start entering it.\n              ")])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lDailyUpdate && _vm.lDailyUpdate.is_sub_app === 0 && _vm.lDailyUpdate.is_app === 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    staticClass: "black--text pa-2",
    attrs: {
      "value": "true",
      "color": "yellow"
    }
  }, [_vm._v("\n                " + _vm._s('Draft, not submitted for approval yet.') + " "), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v(" " + _vm._s('Updated by: ' + (_vm.lDailyUpdate.updated_by_name || ' Vendor FM ') + ' on ' + _vm.handy.formatDBDateTime(_vm.lDailyUpdate.updated_on)))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdate && _vm.lDailyUpdate.is_sub_app && _vm.lDailyUpdate.is_app === 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "color": "orange"
    }
  }, [_vm._v("\n                " + _vm._s('Pending for Approval.')), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s('Updated by: ' + (_vm.lDailyUpdate.updated_by_name || ' Vendor FM ') + ' on ' + _vm.handy.formatDBDateTime(_vm.lDailyUpdate.updated_on)))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdate && _vm.lDailyUpdate.is_app) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lDailyUpdate.app_by) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "color": "success"
    }
  }, [_vm._v("\n                " + _vm._s('Approved.') + " "), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s('By: ' + (_vm.lDailyUpdate.app_by_name || ' Vendor manager ') + ' on ' + _vm.handy.formatDBDateTime(_vm.lDailyUpdate.app_on)) + " ")])])], 1) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-chip', {
    attrs: {
      "color": _vm.enablePreviousDay === true ? 'primary white--text' : ''
    },
    on: {
      "click": _vm.compareWithPreviousDay
    }
  }, [_vm._v("COMPARE WITH PREVIOUS DAY")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showUploadImage = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("insert_photo")]), _vm._v(_vm._s('Photos (' + _vm.lDailyUpdateAttach.fileUrls.length + ')'))], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/attendance/'
      }
    }
  }, [_c('v-btn', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("go to Attendance")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 pr-1 pt-1"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3 pr-0 pl-1",
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pr-0"
  }, _vm._l((_vm.lSummary), function(avg, i) {
    return _c('span', [_c('div', {
      staticClass: "display-1 text-lg-center"
    }, [_vm._v(_vm._s(avg.attAve ? avg.attAve + ' %' : '0 %'))])])
  }), 0)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "xs8": "",
      "sm10": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.attendance : _vm.attendanceSm,
      "items": _vm.lSummary,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: _vm.lSummary.length > 1 && props.index === 0 ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.showAttendanceSummary(props.item.att_dt)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.tot_present))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "red--text lighten-3 pa-2"
        }, [_vm._v(_vm._s(props.item.tot_pend))]), _vm._v(" "), _c('td', {
          staticClass: "black--text lighten-3"
        }, [_vm._v(_vm._s(props.item.tot_staff))])])]
      }
    }], null, false, 600175948)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Attendance Remark If Any",
      "maxlength": "150",
      "hide-details": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.postObserv()
      }
    },
    model: {
      value: (_vm.lDailyUpdate.remark_attendance),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "remark_attendance", $$v)
      },
      expression: "lDailyUpdate.remark_attendance"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Quality "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.enablePreviousDay === true ? _vm.watQualDt : _vm.watQual) : _vm.watQualSm,
      "items": _vm.dailyQualList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.prepareEditWaterQual(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.water_type ? props.item.water_type : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.param_name ? props.item.param_name : '-'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s((props.item.std_val_min ? props.item.std_val_min : 0) + ' to ' + props.item.std_val_max))]) : _vm._e(), _vm._v(" "), _c('td', {
          class: (props.item.val < props.item.std_val_min || props.item.val > props.item.std_val_max) && props.item.val !== null ? 'error white--text' : 'black--text'
        }, [_vm._v(_vm._s(props.item.val ? props.item.val : '-'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(props.item.c_date))]) : _vm._e()])]
      }
    }], null, false, 902797686)
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Water Management "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-2 px-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "px-2 primary--text"
  }, [_vm._v("Water Sources")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.enablePreviousDay === true ? _vm.watTypeDt : _vm.watType,
      "items": _vm.domWatList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.PreapreEditDomWatList(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.water_type ? props.item.water_type : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.water_receipt ? props.item.water_receipt : '-'))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(props.item.c_date ? props.item.c_date : '-'))]) : _vm._e()])]
      }
    }], null, false, 33363164)
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "pb-1 pt-2 pl-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Water Level and Storage")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.enablePreviousDay === true ? _vm.watStorageDt : _vm.watStorage,
      "items": _vm.watList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.PreapreEditWatStorage(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.storage_nm ? props.item.storage_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.water_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_level_checked ? (props.item.water_level ? props.item.water_level : '-') : 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "px-2"
        }, [_vm._v(_vm._s(props.item.is_cons_checked ? (props.item.water_cons === null ? '-' : props.item.water_cons) : 'N/A'))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(props.item.c_date ? props.item.c_date : '-'))]) : _vm._e()])]
      }
    }], null, false, 3040907998)
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Water Management Remark If Any",
      "maxlength": "150",
      "hide-details": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.postObserv()
      }
    },
    model: {
      value: (_vm.lDailyUpdate.remark_water),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "remark_water", $$v)
      },
      expression: "lDailyUpdate.remark_water"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Power Consumption "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])]) : _c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Power "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.enablePreviousDay === true ? _vm.powerConsDt : _vm.powerCons,
      "items": _vm.powerList,
      "no-data-text": "Power consumption is not applicable for this site",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.prepareEditCons(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.meter_nm ? props.item.meter_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.units_cons ? props.item.units_cons : 0))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(props.item.c_date ? props.item.c_date : '-'))]) : _vm._e()])]
      }
    }], null, false, 2870902454)
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Genset Power Consumption, Diesel Level & Stock "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])]) : _c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Genset "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.enablePreviousDay === true ? _vm.genPowerDt : _vm.genPower,
      "items": _vm.gensetList,
      "hide-actions": "",
      "no-data-text": "Genset is not applicable for this site",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.prepareEditGen(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.genset_nm ? props.item.genset_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.units_cons ? props.item.units_cons : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.level ? props.item.level : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.purchased ? props.item.purchased : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.stock ? props.item.stock : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.run_hrs ? props.item.run_hrs : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.kwh_kva ? props.item.kwh_kva : '-'))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(props.item.c_date ? props.item.c_date : '-'))]) : _vm._e()])]
      }
    }], null, false, 1691194196)
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Power Management Remark If Any",
      "maxlength": "150",
      "hide-details": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.postObserv()
      }
    },
    model: {
      value: (_vm.lDailyUpdate.remark_power),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "remark_power", $$v)
      },
      expression: "lDailyUpdate.remark_power"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Waste Management "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.enablePreviousDay === true ? _vm.wasteManaDt : _vm.wasteMana,
      "items": _vm.lWasteList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.c_date !== _vm.lDate ? 'blue lighten-4' : '',
          on: {
            "click": function($event) {
              return _vm.prepareEditWaste(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.waste_type ? props.item.waste_type : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.kgs ? props.item.kgs : 0))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.c_date)))]) : _vm._e()])]
      }
    }], null, false, 511749772)
  })], 1)], 1), _vm._v(" "), (_vm.lSanCheck.length > 0) ? _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Hygiene Management/Sanity Checks "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lSanCheck), function(cat, n) {
    return _c('v-flex', {
      key: n,
      attrs: {
        "xs12": ""
      }
    }, [(cat.check_cat) ? _c('div', {
      staticClass: "pa-2 primary--text"
    }, [_vm._v(_vm._s(cat.check_cat))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.sanCheckList.filter(function (rec) { return rec.check_cat === cat.check_cat; }),
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareEditSanCheck(cat.check_cat)
              }
            }
          }, [_c('td', {
            staticClass: "pr-0",
            style: (_vm.$vuetify.breakpoint.smAndUp ? 'width: 300px;' : 'width: 150px;')
          }, [_vm._v(_vm._s(props.item.check_desc ? props.item.check_desc : '-'))]), _vm._v(" "), _c('td', {
            staticClass: "pt-1 pr-0",
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            attrs: {
              "disabled": "",
              "hide-details": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', [_vm._v("Remarks: " + _vm._s(props.item.remark))]), _vm._v(" "), (_vm.enablePreviousDay === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.c_date)))]) : _vm._e()])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lSanCheck.length > 0) ? _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sanity Checks Remark If Any",
      "maxlength": "150",
      "hide-details": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.postObserv()
      }
    },
    model: {
      value: (_vm.lDailyUpdate.remark_sanity_checks),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "remark_sanity_checks", $$v)
      },
      expression: "lDailyUpdate.remark_sanity_checks"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Custom Metrics "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lMet), function(metric, n) {
    return _c('v-flex', {
      key: n,
      attrs: {
        "xs12": ""
      }
    }, [(metric) ? _c('div', {
      staticClass: "pa-2 primary--text"
    }, [_vm._v(_vm._s(metric.metric_cat))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "headers": _vm.metHead,
        "items": _vm.metricList.filter(function (rec) { return rec.metric_cat === metric.metric_cat; }),
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareEditCusMet(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.metric_nm ? props.item.metric_nm : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.metric_val ? props.item.metric_val : 0))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Custom Metrics Remark If Any",
      "maxlength": "150",
      "hide-details": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.postObserv()
      }
    },
    model: {
      value: (_vm.lDailyUpdate.remark_custom_metrics),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "remark_custom_metrics", $$v)
      },
      expression: "lDailyUpdate.remark_custom_metrics"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2 mt-3"
  }, [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Major Observation")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.enablePreviousDay === true && _vm.dailyUpdatepreviousDayReport.c_date) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "black--text",
    attrs: {
      "value": "true",
      "color": "blue lighten-4"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.handy.formatDBDate(_vm.dailyUpdatepreviousDayReport.c_date) + ': ' + (_vm.dailyUpdatepreviousDayReport.major_observ ? _vm.dailyUpdatepreviousDayReport.major_observ : 'NA')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-editor', {
    attrs: {
      "placeholder": "Major Observation Today If Any",
      "editorToolbar": _vm.handy.customToolbar
    },
    on: {
      "input": function($event) {
        return _vm.limitChar(_vm.lDailyUpdate.major_observ)
      }
    },
    model: {
      value: (_vm.lDailyUpdate.major_observ),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdate, "major_observ", $$v)
      },
      expression: "lDailyUpdate.major_observ"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-right caption grey--text"
  }, [_vm._v("\n          " + _vm._s(_vm.charLen + ' / ' + _vm.charLimit) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    nativeOn: {
      "click": function($event) {
        return _vm.postObserv()
      }
    }
  }, [_vm._v("save")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; top:55px; right:10px;'),
    attrs: {
      "dark": "",
      "fab": "",
      "small": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTimeline = true
      }
    }
  }, [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "900px"
    },
    model: {
      value: (_vm.showSummary),
      callback: function($$v) {
        _vm.showSummary = $$v
      },
      expression: "showSummary"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Attendance Summary "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSummary = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.repHeadSm : _vm.repHead,
      "items": _vm.attReport,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0"
        }, [_vm._v(_vm._s(props.item.tot_present))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "red--text pa-0"
        }, [_vm._v(_vm._s(props.item.tot_pend))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showWaterQual),
      callback: function($$v) {
        _vm.showWaterQual = $$v
      },
      expression: "showWaterQual"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveWatQualChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lWatQual.water_type + ' ' + _vm.lWatQual.param_name) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Value",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "5",
      "type": "number"
    },
    model: {
      value: (_vm.lWatQual.val),
      callback: function($$v) {
        _vm.$set(_vm.lWatQual, "val", $$v)
      },
      expression: "lWatQual.val"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterQual = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showWatStorage),
      callback: function($$v) {
        _vm.showWatStorage = $$v
      },
      expression: "showWatStorage"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveWatStorageChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lWatStorage.storage_nm) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Water Level (%)",
      "disabled": _vm.lWatStorage.is_level_checked === 0,
      "placeholder": _vm.lWatStorage.is_level_checked ? '' : 'N/A',
      "hide-details": "",
      "maxlength": "11",
      "type": "number"
    },
    model: {
      value: (_vm.lWatStorage.water_level),
      callback: function($$v) {
        _vm.$set(_vm.lWatStorage, "water_level", $$v)
      },
      expression: "lWatStorage.water_level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Water Consumption (KL)",
      "hide-details": "",
      "maxlength": "11",
      "type": "number",
      "disabled": _vm.lWatStorage.is_cons_checked === 0,
      "placeholder": _vm.lWatStorage.is_cons_checked ? '' : 'N/A'
    },
    model: {
      value: (_vm.lWatStorage.water_cons),
      callback: function($$v) {
        _vm.$set(_vm.lWatStorage, "water_cons", $$v)
      },
      expression: "lWatStorage.water_cons"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWatStorage = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDomWat),
      callback: function($$v) {
        _vm.showDomWat = $$v
      },
      expression: "showDomWat"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "dForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveDomWatChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lDomWat.water_type) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Water Receipt (KL)",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lDomWat.water_receipt),
      callback: function($$v) {
        _vm.$set(_vm.lDomWat, "water_receipt", $$v)
      },
      expression: "lDomWat.water_receipt"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDomWat = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showPowerCons),
      callback: function($$v) {
        _vm.showPowerCons = $$v
      },
      expression: "showPowerCons"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "pForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.savePowerConsChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lPower.meter_nm) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Units",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "11",
      "type": "number"
    },
    model: {
      value: (_vm.lPower.units_cons),
      callback: function($$v) {
        _vm.$set(_vm.lPower, "units_cons", $$v)
      },
      expression: "lPower.units_cons"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPowerCons = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showPowerGen),
      callback: function($$v) {
        _vm.showPowerGen = $$v
      },
      expression: "showPowerGen"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "gForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.savePowerGenChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lGenset.genset_nm) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 pl-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Power")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Units Generated",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "11",
      "type": "number"
    },
    model: {
      value: (_vm.lGenset.units_cons),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "units_cons", $$v)
      },
      expression: "lGenset.units_cons"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 pt-3 pl-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Diesel")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Level (%)",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "5",
      "type": "number"
    },
    model: {
      value: (_vm.lGenset.level),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "level", $$v)
      },
      expression: "lGenset.level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Purchased (ltr)",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "7",
      "type": "number"
    },
    model: {
      value: (_vm.lGenset.purchased),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "purchased", $$v)
      },
      expression: "lGenset.purchased"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Stock (ltr)",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "7",
      "type": "number"
    },
    model: {
      value: (_vm.lGenset.stock),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "stock", $$v)
      },
      expression: "lGenset.stock"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Running Hours",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lGenset.run_hrs),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "run_hrs", $$v)
      },
      expression: "lGenset.run_hrs"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "KWH/KVA",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lGenset.kwh_kva),
      callback: function($$v) {
        _vm.$set(_vm.lGenset, "kwh_kva", $$v)
      },
      expression: "lGenset.kwh_kva"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPowerGen = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showWaste),
      callback: function($$v) {
        _vm.showWaste = $$v
      },
      expression: "showWaste"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "wForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveWasteChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lWaste.waste_type + ' Waste') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Kgs",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "5",
      "type": "number"
    },
    model: {
      value: (_vm.lWaste.kgs),
      callback: function($$v) {
        _vm.$set(_vm.lWaste, "kgs", $$v)
      },
      expression: "lWaste.kgs"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaste = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showCusMet),
      callback: function($$v) {
        _vm.showCusMet = $$v
      },
      expression: "showCusMet"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "mForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMetChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n            " + _vm._s(_vm.lMetric.metric_nm) + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Value",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "5",
      "type": "number"
    },
    model: {
      value: (_vm.lMetric.metric_val),
      callback: function($$v) {
        _vm.$set(_vm.lMetric, "metric_val", $$v)
      },
      expression: "lMetric.metric_val"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCusMet = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "900px"
    },
    model: {
      value: (_vm.showUploadImage),
      callback: function($$v) {
        _vm.showUploadImage = $$v
      },
      expression: "showUploadImage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_c('div', [_vm._v(_vm._s('Photos (' + _vm.handy.formatDate(_vm.lDate) + ')'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showUploadImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.photoCatChips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "color": _vm.lDailyUpdateAttach.cat === chip.attach_cat_id ? 'primary white--text' : ''
      },
      on: {
        "click": function($event) {
          return _vm.loadCategoryImage(chip.attach_cat_id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(chip.attach_cat_name + (_vm.lDailyUpdateAttach.fileUrls ? (_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length ? (' (' + _vm.lDailyUpdateAttach.fileUrls.filter(function (rec) { return rec.attach_cat_id === chip.attach_cat_id; }).length + ')') : '') : '')))])], 1)
  }), _vm._v(" "), _c('v-chip', {
    attrs: {
      "color": _vm.lDailyUpdateAttach.cat === 'All' ? 'primary white--text' : ''
    },
    on: {
      "click": function($event) {
        return _vm.loadCategoryImage('All')
      }
    }
  }, [_vm._v("All (" + _vm._s(_vm.lDailyUpdateAttach.fileUrls && _vm.lDailyUpdateAttach.fileUrls.length) + ")")])], 2)], 1), _vm._v(" "), _c('v-card-text', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": file.file_url
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "right": "5px"
      }
    }, [_c('v-menu', {
      staticClass: "mt-0",
      attrs: {
        "top": "",
        "right": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "small": "",
              "color": "grey lighten-2"
            }
          }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      staticClass: "py-0"
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.PrepareNotes(file)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("notes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Notes")])], 1), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.PrepareUpdateCat(file)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update category")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletePhoto(file)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete photo")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n                " + _vm._s(file.notes) + "\n              ")]) : _vm._e()])], 1)
  }), 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', [_c('div', {
    staticClass: "pa-2"
  }, [_vm._v("No photos are taken yet.")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs0": ""
    }
  }, [_c('v-spacer')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center text-sm-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "dark": "",
      "fab": "",
      "color": "accent"
    },
    on: {
      "click": _vm.prepareCamera
    }
  }, [_c('v-icon', [_vm._v("photo_camera")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.showCamera),
      callback: function($$v) {
        _vm.showCamera = $$v
      },
      expression: "showCamera"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('video', {
    staticStyle: {
      "width": "280px",
      "height": "210px"
    },
    attrs: {
      "id": "cam",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.photoCatChips,
      "item-value": "attach_cat_id",
      "item-text": "attach_cat_name",
      "label": "Category",
      "hide-details": "",
      "rules": [_vm.rules.required],
      "solo": ""
    },
    model: {
      value: (_vm.lDailyUpdateAttach.attach_cat_id),
      callback: function($$v) {
        _vm.$set(_vm.lDailyUpdateAttach, "attach_cat_id", $$v)
      },
      expression: "lDailyUpdateAttach.attach_cat_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pb-3 pt-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.capturePhoto
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "10px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCamDlg($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showNotes),
      callback: function($$v) {
        _vm.showNotes = $$v
      },
      expression: "showNotes"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      Add or Update Notes\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Notes",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: (_vm.lNotes.notes),
      callback: function($$v) {
        _vm.$set(_vm.lNotes, "notes", $$v)
      },
      expression: "lNotes.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showNotes = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.saveNotes(_vm.lNotes)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showCats),
      callback: function($$v) {
        _vm.showCats = $$v
      },
      expression: "showCats"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      Update Category\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.photoCatChips,
      "item-value": "attach_cat_id",
      "item-text": "attach_cat_name",
      "label": "Category",
      "hide-details": "",
      "rules": [_vm.rules.required],
      "solo": ""
    },
    model: {
      value: (_vm.lCat.attach_cat_id),
      callback: function($$v) {
        _vm.$set(_vm.lCat, "attach_cat_id", $$v)
      },
      expression: "lCat.attach_cat_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCats = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.saveCats(_vm.lCat)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lTimeLine), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lTimeLine.length - 1 ? 'pb-0' : '',
      attrs: {
        "color": "red lighten-2",
        "small": "",
        "icon": "star",
        "fill-dot": "",
        "id": 'timeline_' + n
      }
    }, [_c('v-card', [_c('v-card-text', [_vm._v("\n            " + _vm._s(timeline.updated_by_name) + " has\n            "), (timeline.category === 'Attach the photos' || timeline.category === 'Submitted for Approval' || timeline.category === 'Approved') ? _c('span') : _c('span', [_vm._v("updated")]), _vm._v("\n            " + _vm._s(timeline.category) + "\n            "), _c('span', {
      staticClass: "grey--text pl-1"
    }, [_vm._v("on " + _vm._s(_vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "650px"
    },
    model: {
      value: (_vm.showSanCheck),
      callback: function($$v) {
        _vm.showSanCheck = $$v
      },
      expression: "showSanCheck"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [(_vm.sanCheck.length > 0) ? _c('div', {
    staticClass: "title grey--text"
  }, [_vm._v(_vm._s(_vm.sanCheck[0].check_cat) + " "), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s('[' + _vm.handy.formatDate(_vm.lDate) + ']'))])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSanCheck = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, _vm._l((_vm.sanCheck), function(sanity, n) {
    return _c('v-flex', {
      key: n,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      staticClass: "pb-1",
      attrs: {
        "disabled": "",
        "hide-details": ""
      },
      model: {
        value: (sanity.check_desc),
        callback: function($$v) {
          _vm.$set(sanity, "check_desc", $$v)
        },
        expression: "sanity.check_desc"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "pl-3",
      attrs: {
        "xs1": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "disabled": sanity.check_desc === 'Garbage Disposal' ? true : false,
        "hide-details": ""
      },
      model: {
        value: (sanity.check_value),
        callback: function($$v) {
          _vm.$set(sanity, "check_value", $$v)
        },
        expression: "sanity.check_value"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('v-text-field', {
      staticClass: "pb-1",
      attrs: {
        "placeholder": "Add remark if any",
        "disabled": sanity.check_desc === 'Garbage Disposal' ? true : false,
        "hide-details": ""
      },
      model: {
        value: (sanity.remark),
        callback: function($$v) {
          _vm.$set(sanity, "remark", $$v)
        },
        expression: "sanity.remark"
      }
    })], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    on: {
      "click": function($event) {
        return _vm.saveSanCheck(_vm.sanCheck, null)
      }
    }
  }, [_vm._v("save")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-f49e9ff2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dailyupdate.vue
// module id = 867
// module chunks = 14